<template>
  <el-card style="width: 500px;margin:20px auto">
    <el-form label-width="80px" size="small">
      <el-upload
          class="avatar-uploader"
          action="http://localhost:9098/file/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
      >
        <img v-if="form.userImage" :src="form.userImage" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>

      <el-form-item label="用户名">
        <el-input v-model="form.username" disabled style="width: 85%" size="default"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-input v-model="form.userRole" disabled style="width: 85%" size="default"></el-input>
      </el-form-item>
      <el-form-item label="真实名称">
        <el-input v-model="form.realName" style="width: 85%" size="default"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model="form.email" style="width: 85%" size="default"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input v-model="form.phone" style="width: 85%" size="default"></el-input>
      </el-form-item>
      <el-form-item label="单位">
        <el-input type="textarea" v-model="form.workUnit" style="width: 85%" size="default"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">确 定</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>

import store from "@/store";
import axios from "axios";

export default {
  name: "Person",
  data() {
    return {
      serverIp: 'ip',
      form: {},
      //user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}

    }
  },
  created() {
    // this.getUser().then(res => {
    //   console.log(res)
    //   this.form = res
    // })
       console.log("用户信息",store.getters.user)
    //   this.form = res
    this.form = store.getters.user.data
  },
  methods: {
    async getUser() {
      return (await this.request.get("/user/username/" + this.user.username)).data
    },
    save() {

      console.log("修改的用户：",this.form)


      axios.post("/api/update", this.form).then(res => {

        console.log("成功",res)
        if (res.status === 200) {
          this.$message.success("保存成功")

          this.form = res.data.data;
          console.log("成功2", this.form)

          
          //删除store
          store.dispatch('login', this.form); // 将用户信息存储到 Vuex


          // this.$router.push("/person")
          this.$store.dispatch('logout'); // 调用 logout action


          store.dispatch('login', this.form); // 将用户信息存储到 Vuex

        } else {
          this.$message.error("保存失败")
        }
      })
    },
    handleAvatarSuccess(res) {
      this.form.userImage = res
    }
  }
}
</script>

<style>
.avatar-uploader {
  text-align: center;
  padding-bottom: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  line-height: 138px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>
